import {
  MessageOutlined,
  MessageFilled,
  UserOutlined,
  PictureOutlined,
  PictureFilled,
} from "@ant-design/icons";
import styled from "@emotion/styled";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constant/routes";

const StyledBottomNavigation = styled.div`
  display: flex;
  background: var(--primary);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 10000;
  .nav-button {
    flex: 1;
    background: transparent;
    border: none;
    padding: 12px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    transition: all 0.2s;
    color: #ffffff;
    border-right: 1px solid var(--primary);
    border-left: 1px solid var(--primary);
  }

  .nav-button.active {
    background: linear-gradient(90deg, #7b3bea 0%, #28c665 100%);
    border-right: 1px solid white !important;
    border-left: 1px solid white !important;
    color: white;
  }

  .nav-button .anticon {
    font-size: 22px;
  }

  .nav-button-label {
    font-size: 12px;
    font-weight: 400;
  }
`;
const BottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <StyledBottomNavigation className="bottom-navigation">
      <button
        className={`nav-button ${location.pathname === ROUTES.CHATS ? "active" : ""}`}
        onClick={() => navigate(ROUTES.CHATS)}
      >
        {location.pathname === ROUTES.CHATS ? (
          <MessageFilled />
        ) : (
          <MessageOutlined />
        )}
        <span className="nav-button-label">Chats</span>
      </button>
      <button
        className={`nav-button ${location.pathname === ROUTES.POSTER ? "active" : ""}`}
        onClick={() => navigate(ROUTES.POSTER)}
      >
        {location.pathname === ROUTES.POSTER ? (
          <PictureFilled />
        ) : (
          <PictureOutlined />
        )}
        <span className="nav-button-label">Poster</span>
      </button>
      <button
        className={`nav-button ${location.pathname === ROUTES.PROFILE ? "active" : ""}`}
        onClick={() => navigate(ROUTES.PROFILE)}
      >
        <UserOutlined />
        <span className="nav-button-label">Profile</span>
      </button>
    </StyledBottomNavigation>
  );
};

export default BottomNavigation;
